<template>
  <section>
    <InfoAudience
      class="info-audience"
      :is-loading="participantLoading"
      :participant="participant"
    />
    <section class="bg-white-100">
      <aha-multi-tabs
        class="px-4 tab-section"
        @onChangeTab="onChangeTab"
        :tabTitles="tabTitles"
        :defaultTabIndex="0"
      >
      </aha-multi-tabs>
      <KeepAlive>
        <component
          :is="selectedTabComponent"
          :presentation-id="presentationId"
          :audience-id="audienceId"
        >
        </component>
      </KeepAlive>
    </section>
  </section>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import Responses from '@/components-v2/presentation-report/ReportAudienceDetail/Responses.vue'
import InfoAudience from '@/components-v2/presentation-report/ReportAudienceDetail/InfoAudience.vue'

export default {
  components: {
    InfoAudience,
    Responses,
  },
  props: {
    presentationId: {
      type: String,
      required: true,
    },
    audienceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      participantLoading: false,
      selectedTabComponent: Responses.name,
    }
  },
  computed: {
    ...mapGetters('presentationReport', [
      'participant',
    ]),
    tabs() {
      return [
        Responses,
      ]
    },
    tabTitles() {
      return this.tabs.map((tab) => tab.title)
    },
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    ...mapActions('presentationReport', [
      'getParticipant',
    ]),
    onChangeTab(index) {
      this.selectedTabComponent = this.tabs[index]?.name
    },
    async getInfo() {
      this.participantLoading = true
      try {
        await this.getParticipant({
          presentationId: this.presentationId,
          audienceId: this.audienceId,
        })
      } catch (e) {
        Sentry.captureException(e)
      } finally {
        this.participantLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-section {
  @apply border-secondary-20;

  border-block-width: 1px;
  border-block-style: solid;

  &::v-deep {
    &.is-single {
      @apply py-4;
    }
  }
}

.info-audience {
  z-index: 1;
}
</style>
